// extracted by css-extract-rspack-plugin
export default {"cls1":"SavedReferencesList-cls1_3lv","cls2":"SavedReferencesList-cls2_ZNs SavedReferencesList-cls1_3lv"};